// FW-4593 Map legacy URLS into new site names
// generated via:

//  curl https://www.firstvoices.com/nuxeo/api/v1/site/ | jq '[ (.[] as $p | ($p.path | sub("/FV/(workspaces|sections)/data/"; ""; "i") | split("/") | {family: .[0], language: .[1], dialect: .[2]}) + {oldSitename: $p.sitename, newSiteName: $p.sitename} ) ]'

// manual edits as required

const LEGACY_SITE_MAPPING = [
  {
    family: 'Salishan',
    language: "Hul'q'umi'num'",
    dialect: 'hwulmuhwqun',
    oldSitename: 'hwulmuhwqun',
    newSiteName: 'hwulmuhwqun',
  },
  {
    family: 'Iroquoian language family',
    language: 'huron-wendat',
    dialect: 'huron-wendat-Eng',
    oldSitename: 'Huronne-Wendat-EN',
    newSiteName: 'huron-wendat-en',
  },
  {
    family: 'famille linguistique iroquoienne',
    language: 'huron-wendat',
    dialect: 'huron-wendat-FR',
    oldSitename: 'Huronne-Wendat',
    newSiteName: 'huronne-wendat-fr',
  },
  {
    family: 'Athabascan',
    language: 'Danezāgé’',
    dialect: 'Denek’éh-Kaska',
    oldSitename: 'denekeh-kaska-liard',
    newSiteName: 'denekeh-kaska-liard',
  },
  {
    family: 'Tsimshianic',
    language: 'Sm̓algya̱x',
    dialect: "kitsumkalum sm'algyax",
    oldSitename: 'smalgyax-kitsumkalum',
    newSiteName: 'smalgyax-kitsumkalum',
  },
  {
    family: 'Kanehsatà:ke',
    language: 'Mohawk',
    dialect: "Kanien'kéha (Mohawk) Eng",
    oldSitename: 'Kanienkeha-Mohawk-EN',
    newSiteName: 'kanienkeha-mohawk-en',
  },
  {
    family: 'Kanehsatà:ke',
    language: 'Mohawk',
    dialect: "Kanien'kéha (Mohawk) [Eng]",
    oldSitename: 'Kanienkeha-Mohawk-EN',
    newSiteName: 'kanienkeha-mohawk-en',
  },
  {
    family: 'Secwepemc',
    language: 'Secwepemctsin',
    dialect: 'Splatsin (Eastern dialect)',
    oldSitename: 'splatsin',
    newSiteName: 'splatsin',
  },
  {
    family: 'Demonstration',
    language: 'Gumbayngirr',
    dialect: 'Gumbaynggirr',
    oldSitename: 'gumbayngirr',
    newSiteName: 'gumbayngirr',
  },
  {
    family: 'Wakashan',
    language: 'Kwak̓wala',
    dialect: 'Liq̓ʷala',
    oldSitename: 'liqwala',
    newSiteName: 'liqwala',
  },
  {
    family: 'Athabascan',
    language: 'Dene K’e',
    dialect: 'Dene K’e',
    oldSitename: 'dene-keh-slavey',
    newSiteName: 'dene-keh-slavey',
  },
  {
    family: 'Plains Cree (Y)',
    language: 'Cree',
    dialect: 'Cree (Saulteau First Nation)',
    oldSitename: 'cree-saulteau',
    newSiteName: 'cree-saulteau',
  },
  {
    family: "Kwak'wala",
    language: 'Kwak̓wala',
    dialect: "'Nak̕wala-Gwat̕sala",
    oldSitename: 'nakwala-gwatsala',
    newSiteName: 'nakwala-gwatsala',
  },
  {
    family: 'Alqonquin',
    language: 'Nēhiyawēwin',
    dialect: 'nêhiyawêwin',
    oldSitename: 'pafnw-nehiyawewin',
    newSiteName: 'pafnw-nehiyawewin',
  },
  {
    family: 'Wakashan',
    language: 'Hailhzaqvla',
    dialect: 'Xaiʔxais',
    oldSitename: 'xaixais',
    newSiteName: 'xaixais',
  },
  {
    family: 'Demonstration',
    language: 'Esperanto',
    dialect: 'Esperanto',
    oldSitename: 'esperanto',
    newSiteName: 'esperanto',
  },
  {
    family: 'Athabascan',
    language: 'Dene K’e',
    dialect: 'K’áhshó got’ı̨né xǝdǝ́',
    oldSitename: 'kahsho-gotine',
    newSiteName: 'kahsho-gotine',
  },
  {
    family: 'scw̓exmxcÌn',
    language: 'nłeʔkepmxcin',
    dialect: 'Nlakapamuxcheen',
    oldSitename: 'nlakapamuxcheen',
    newSiteName: 'nlakapamuxcheen',
  },
  {
    family: "Kwak'wala",
    language: 'Kwak̓wala',
    dialect: 'Kwak̓wala',
    oldSitename: 'kwakwala',
    newSiteName: 'kwakwala',
  },
  {
    family: 'Plains Cree (Y)',
    language: 'Cree',
    dialect: 'Maskwacis-Cree',
    oldSitename: 'maskwacis-cree',
    newSiteName: 'maskwacis-cree',
  },
  {
    family: 'Wakashan',
    language: 'Hailhzaqvla',
    dialect: 'Hailhzaqvla',
    oldSitename: 'hailzaqvla',
    newSiteName: 'hailzaqvla',
  },
  {
    family: 'Wakashan',
    language: 'diidiitidq',
    dialect: 'diiɁdiitidq',
    oldSitename: 'diidiitidq',
    newSiteName: 'diidiitidq',
  },
  {
    family: 'Athabascan',
    language: 'Dene',
    dialect: 'Dene',
    oldSitename: 'dene-suline',
    newSiteName: 'dene-suline',
  },
  {
    family: 'Haisla',
    language: 'Haisla',
    dialect: 'Haisla',
    oldSitename: 'haisla',
    newSiteName: 'haisla',
  },
  {
    family: 'Yukon',
    language: 'Southern Tutchone',
    dialect: 'Southern Tutchone',
    oldSitename: 'southern-tutchone',
    newSiteName: 'southern-tutchone',
  },
  {
    family: 'Salish',
    language: 'Northern Salishan',
    dialect: 'Klahoose',
    oldSitename: 'klahoose',
    newSiteName: 'klahoose',
  },
  {
    family: 'scw̓exmxcÌn',
    language: 'nłeʔkepmxcin',
    dialect: 'nłeʔkepmxcin',
    oldSitename: 'nlekepmxcin',
    newSiteName: 'nlekepmxcin',
  },
  {
    family: 'c̕išaaʔatḥ',
    language: 'Nuučaan̓uɫ',
    dialect: 'c̕išaaʔatḥ',
    oldSitename: 'tseshahtlanguage',
    newSiteName: 'tseshahtlanguage',
  },
  {
    family: 'Athabascan',
    language: 'Dene',
    dialect: 'Tāłtān',
    oldSitename: 'tahltan',
    newSiteName: 'tahltan',
  },
  {
    family: 'Athabascan',
    language: 'Yekooche',
    dialect: 'Yekooche',
    oldSitename: 'yekooche',
    newSiteName: 'yekooche',
  },
  {
    family: 'Coast Salish',
    language: 'Halkomelem',
    dialect: "HUL'Q'UMI'NUM'",
    oldSitename: 'hulquminum',
    newSiteName: 'hulquminum',
  },
  {
    family: 'Athabascan',
    language: "Tse'Khene (McLeod Lake)",
    dialect: "Tse'Khene (McLeod Lake)",
    oldSitename: 'tsekhene-mcleod',
    newSiteName: 'tsekhene-mcleod',
  },
  {
    family: 'Wakashan',
    language: '’Uik̓ala',
    dialect: '’Uik̓ala',
    oldSitename: 'wuikala',
    newSiteName: 'wuikala',
  },
  {
    family: 'Salishan',
    language: "Hul'q'umi'num'",
    dialect: "Penelakut Hul'q'umi'num'",
    oldSitename: 'penelakut-hulquminum',
    newSiteName: 'penelakut-hulquminum',
  },
  {
    family: 'Salish',
    language: 'Northern Salishan',
    dialect: 'Sliammon',
    oldSitename: 'tlaamin',
    newSiteName: 'tlaamin',
  },
  {
    family: 'Yukon',
    language: 'Tagish',
    dialect: 'Tagish',
    oldSitename: 'tagish',
    newSiteName: 'tagish',
  },
  {
    family: 'St̕át̕imc',
    language: "Lil'wat",
    dialect: 'Líl̓wat',
    oldSitename: 'lilwat',
    newSiteName: 'lilwat',
  },
  {
    family: 'Nuu-chah-nulth',
    language: 'Nuučaan̓uɫ',
    dialect: 'Kyuquot-Checleseht',
    oldSitename: 'kyuquot-checleseht',
    newSiteName: 'kyuquot-checleseht',
  },
  {
    family: 'Athabascan',
    language: "Gwich'in",
    dialect: "Vuntut Gwich'in",
    oldSitename: 'vuntut-gwichin',
    newSiteName: 'vuntut-gwichin',
  },
  {
    family: 'Athabascan',
    language: 'Northern Tutchone (Na-Cho Nyak Dun)',
    dialect: 'Northern Tutchone (Na-Cho Nyak Dun)',
    oldSitename: 'northern-tutchone-na-cho-nyak-dun',
    newSiteName: 'northern-tutchone-na-cho-nyak-dun',
  },
  {
    family: 'Salish',
    language: 'she shashishalhem',
    dialect: 'she shashishalhem',
    oldSitename: 'she-shashishalhem',
    newSiteName: 'she-shashishalhem',
  },
  {
    family: 'Nuu-chah-nulth',
    language: 'Nuučaan̓uɫ',
    dialect: 'Nuu-chah-nulth (Barkley)',
    oldSitename: 'nuu-chah-nulth-barkley',
    newSiteName: 'nuu-chah-nulth-barkley',
  },
  {
    family: "Sim'algaxm - Gitksen",
    language: 'Gitsenimx̱',
    dialect: 'Gitsenimx̱',
    oldSitename: 'gitsenimx',
    newSiteName: 'gitsenimx',
  },
  {
    family: 'Salishan',
    language: 'St̓át̓imcets',
    dialect: "Nkúkwtsa Stl'atl'imx",
    oldSitename: 'nkukwtsa-stlatlimx',
    newSiteName: 'nkukwtsa-stlatlimx',
  },
  {
    family: 'Athabascan',
    language: 'Nedut’en',
    dialect: 'Nedut’en',
    oldSitename: 'neduten-lake-babine',
    newSiteName: 'neduten-lake-babine',
  },
  {
    family: 'Athabascan',
    language: 'Beaver',
    dialect: 'Tsaaʔ Dane - Beaver People',
    oldSitename: 'tsaa-dane-beaver',
    newSiteName: 'tsaa-dane-beaver',
  },
  {
    family: 'Athabascan',
    language: 'Kaska',
    dialect: 'Denek’éh_Kaska',
    oldSitename: 'denekeh-kaska',
    newSiteName: 'denekeh-kaska',
  },
  {
    family: "Hulqumi'num",
    language: 'Snuneymuxw First Nation',
    dialect: 'Snuneymuxw First Nation',
    oldSitename: 'snuneymuxw',
    newSiteName: 'snuneymuxw',
  },
  {
    family: 'Secwepemc',
    language: 'Secwepemctsin',
    dialect: 'Secwepemctsin (Eastern Dialect)',
    oldSitename: 'secwepemctsin-eastern',
    newSiteName: 'secwepemctsin-eastern',
  },
  {
    family: "Kanien'kéha (Mohawk)",
    language: 'Mohawk',
    dialect: "Kanien'kéha (Mohawk) FR",
    oldSitename: 'Kanienkeha-Mohawk-FR',
    newSiteName: 'kanienkeha-mohawk-fr',
  },
  {
    family: 'Athabascan',
    language: 'Dakelh',
    dialect: "Saik'uz Dakelh",
    oldSitename: 'saikuz-dakelh',
    newSiteName: 'saikuz-dakelh',
  },
  {
    family: 'Haida',
    language: 'Hlg̱aagilda X̱aayda Kil',
    dialect: 'Hlg̱aagilda X̱aayda Kil',
    oldSitename: 'hlgaagilda-xaayda-kil',
    newSiteName: 'hlgaagilda-xaayda-kil',
  },
  {
    family: 'Tsimshianic',
    language: 'Sm̓algya̱x',
    dialect: "Metlakatla Sm'algyax",
    oldSitename: 'smalgyax-metlakatla',
    newSiteName: 'smalgyax-metlakatla',
  },
  {
    family: 'nsyilxcən',
    language: 'nsyilxcən',
    dialect: 'Syilx',
    oldSitename: 'syilx',
    newSiteName: 'syilx',
  },
  {
    family: 'Salishan',
    language: 'Sḵwxwú7mesh sníchim',
    dialect: 'Sḵwx̱wú7mesh',
    oldSitename: 'squamish',
    newSiteName: 'squamish',
  },
  {
    family: 'Ktunaxa',
    language: 'Ktunaxa',
    dialect: 'Ktunaxa',
    oldSitename: 'ktunaxa',
    newSiteName: 'ktunaxa',
  },
  {
    family: 'Coast Salish',
    language: 'Éy7á7juuthem',
    dialect: 'Homalco',
    oldSitename: 'homalco',
    newSiteName: 'homalco',
  },
  {
    family: 'Coast Salish',
    language: 'Halkomelem',
    dialect: 'Stz’uminus',
    oldSitename: 'stzuminus',
    newSiteName: 'stzuminus',
  },
  {
    family: 'Tsimshianic',
    language: 'Sgüüx̣s',
    dialect: 'Sgüüx̣s',
    oldSitename: 'sguuxs',
    newSiteName: 'sguuxs',
  },
  {
    family: 'Wakashan',
    language: 'Nuučaan̓uɫ',
    dialect: 'ƛaʔuukʷiʔatḥ ciqyakquuki',
    oldSitename: 'tlaoquiaht-ciqyakquukin',
    newSiteName: 'tlaoquiaht-ciqyakquukin',
  },
  {
    family: 'Wakashan',
    language: 'Nuučaan̓uɫ',
    dialect: 'ḥiškʷiiʔatḥ',
    oldSitename: 'hesquiaht',
    newSiteName: 'hesquiaht',
  },
  {
    family: 'Wakashan',
    language: 'Nuučaan̓uɫ',
    dialect: 'Ehattesaht Nuchatlaht',
    oldSitename: 'ehattesaht-nuchatlaht',
    newSiteName: 'ehattesaht-nuchatlaht',
  },
  {
    family: 'Salish',
    language: 'Nuxalk',
    dialect: 'Nuxalk',
    oldSitename: 'nuxalk',
    newSiteName: 'nuxalk',
  },
  {
    family: 'nsyilxcən',
    language: 'nsyilxcən',
    dialect: 'nsyilxcən',
    oldSitename: 'nsyilxcen',
    newSiteName: 'nsyilxcen',
  },
  {
    family: 'Secwepemc',
    language: 'Secwepemctsin',
    dialect: 'Secwepemc',
    oldSitename: 'secwepemc',
    newSiteName: 'secwepemc',
  },
  {
    family: 'Athabascan',
    language: 'Dakelh',
    dialect: 'Dakelh _ Southern Carrier',
    oldSitename: 'dakelh-southern-carrier',
    newSiteName: 'dakelh-southern-carrier',
  },
  {
    family: "Ts'msyen",
    language: 'Sm’algyax',
    dialect: "Sm'algya̱x",
    oldSitename: 'smalgyax-beta',
    newSiteName: 'smalgyax',
  },
  {
    family: "Nisga'a",
    language: "Nisga'a",
    dialect: "Nisga'a",
    oldSitename: 'nisgaa',
    newSiteName: 'nisgaa',
  },
  {
    family: 'Athabascan',
    language: "Kwadacha Tsek'ene",
    dialect: "Kwadacha Tsek'ene",
    oldSitename: 'kwadacha-tsekene',
    newSiteName: 'kwadacha-tsekene',
  },
  {
    family: 'Alqonquin',
    language: 'Anishinaabemowin',
    dialect: 'Anihšināpēmowin',
    oldSitename: 'pafnw-anihsinapemowin',
    newSiteName: 'pafnw-anihsinapemowin',
  },
  {
    family: 'Alqonquin',
    language: "Mi'kmaw",
    dialect: "Mi'kmaw",
    oldSitename: 'mikmaw',
    newSiteName: 'mikmaw',
  },
  {
    family: 'Athabascan',
    language: 'Dakelh',
    dialect: "Nadleh Whut'en",
    oldSitename: 'nadleh-stella-whutenne',
    newSiteName: 'nadleh-stella-whutenne',
  },
  {
    family: 'Athabascan',
    language: 'Hän',
    dialect: 'Hän',
    oldSitename: 'han',
    newSiteName: 'han',
  },
  {
    family: 'Salishan',
    language: 'Lekwungen',
    dialect: 'x̣ʷsépsəm lək̓ʷáŋən',
    oldSitename: 'lekwungen',
    newSiteName: 'lekwungen',
  },
  {
    family: 'Athabascan',
    language: "Tsilhqot'in (Xeni Gwet'in)",
    dialect: "Tsilhqot'in (Xeni Gwet'in)",
    oldSitename: 'tsilhqotin-xeni-gwetin',
    newSiteName: 'tsilhqotin-xeni-gwetin',
  },
  {
    family: 'Athabascan',
    language: 'Dakelh',
    dialect: "Tl'azt'en",
    oldSitename: 'tlazten-dakelh',
    newSiteName: 'tlazten-dakelh',
  },
  {
    family: 'Pama-nyugan',
    language: 'Gathang',
    dialect: 'Gathang',
    oldSitename: 'gathang',
    newSiteName: 'gathang',
  },
  {
    family: "Kwak'wala",
    language: 'Kwak̓wala',
    dialect: 'Kwakiutl',
    oldSitename: 'kwakiutl',
    newSiteName: 'kwakiutl',
  },
  {
    family: 'Athabascan',
    language: 'Witsuwit’en',
    dialect: 'Witsuwit’en',
    oldSitename: 'witsuwiten',
    newSiteName: 'witsuwiten',
  },
  {
    family: 'Haida',
    language: 'x_aad kil (Massett Haida)',
    dialect: 'x̱aad kil (Massett Haida)',
    oldSitename: 'xaad-kil-massett',
    newSiteName: 'xaad-kil-massett',
  },
  {
    family: 'THE SENĆOŦEN LANGUAGE',
    language: 'SENĆOŦEN',
    dialect: 'SENĆOŦEN',
    oldSitename: 'sencoten',
    newSiteName: 'sencoten',
  },
  {
    family: 'Athabascan',
    language: 'Dakelh',
    dialect: 'Nak’azdli Dakelh',
    oldSitename: 'nakazdli-dakelh',
    newSiteName: 'nakazdli-dakelh',
  },
  {
    family: 'Interior Salish',
    language: 'Northern St̕át̕imcets',
    dialect: 'Northern St̓át̓imcets',
    oldSitename: 'northern-statimcets',
    newSiteName: 'northern-statimcets',
  },
  {
    family: 'Salish',
    language: 'Halkomelem',
    dialect: "Halq'eméylem",
    oldSitename: 'halqemeylem',
    newSiteName: 'halqemeylem',
  },
  {
    family: 'Athabascan',
    language: 'Lingít',
    dialect: 'C_TFN Tlingit',
    oldSitename: 'ctfn-tlingit',
    newSiteName: 'ctfn-tlingit',
  },
  {
    family: 'Luiseno',
    language: 'Cupeno',
    dialect: 'Cupeno',
    oldSitename: 'cupeno',
    newSiteName: 'cupeno',
  },
  {
    family: "Sim'algaxm - Gitksen",
    language: 'Gitsenimx̱',
    dialect: 'Gigeenix Gitxsanimx̱',
    oldSitename: 'gigeenix-gitxsanimx',
    newSiteName: 'gigeenix-gitxsanimx',
  },
  {
    family: 'Tsimshianic',
    language: 'Sm̓algya̱x',
    dialect: "Gitxaała Sm'algyax",
    oldSitename: "Gitxaała Sm'algyax",
    newSiteName: 'gitxaala',
  },
  {
    family: 'Central Coast Salish',
    language: 'Halkomelem',
    dialect: 'hən̓q̓əmin̓əm̓',
    oldSitename: 'henqeminem',
    newSiteName: 'henqeminem',
  },
  {
    family: 'scw̓exmxcÌn',
    language: 'nłeʔkepmxcin',
    dialect: 'nƛ̓əq̓ƛ̓áq̓tn / Kanaka B',
    oldSitename: 'kanakabar',
    newSiteName: 'kanakabar',
  },
  {
    family: 'Coast Salish',
    language: 'Éy7á7juuthem',
    dialect: "K'omoks",
    oldSitename: "K'omoks",
    newSiteName: 'komoks',
  },
  {
    family: 'Demonstration',
    language: 'Kwak̓wala',
    dialect: 'kʷak̓ʷala',
    oldSitename: 'kwakwala-2',
    newSiteName: 'kwakwala-2',
  },
  {
    family: 'Demonstration',
    language: 'Liq¿ildax¿',
    dialect: 'Liqʷiłdaxʷ',
    oldSitename: 'liqwildaxw',
    newSiteName: 'liqwildaxw',
  },
  {
    family: 'Luiseno',
    language: 'Luiseno',
    dialect: 'Luiseno',
    oldSitename: 'luiseno',
    newSiteName: 'luiseno',
  },
  {
    family: 'Athabascan',
    language: 'Northern Tutchone (Selkirk)',
    dialect: 'Northern Tutchone (Selkirk)',
    oldSitename: 'northern-tutchone-selkirk',
    newSiteName: 'northern-tutchone-selkirk',
  },
  {
    family: "Kwak'wala",
    language: 'Kwak̓wala',
    dialect: 'Q̓ʷəl̓gəƛəla Yaq̓əndas',
    oldSitename: 'Q̓ʷəl̓gəƛəla Yaq̓əndas',
    newSiteName: 'qwelgetlela-yaqendas',
  },
  {
    family: 'Athabascan',
    language: 'Southern Tutchone',
    dialect: 'Southern Tutchone (Kluane)',
    oldSitename: 'Southern Tutchone (Kluane)',
    newSiteName: 'southern-tutchone-kluane',
  },
  {
    family: 'nsyilxcən',
    language: 'nsyilxcən',
    dialect: 'Syilx Language House',
    oldSitename: 'syilx-language-house',
    newSiteName: 'syilx-language-house',
  },
  {
    family: 'Wakashan',
    language: 'Nuučaan̓uɫ',
    dialect: 'ƛaʔuukʷiʔatḥ',
    oldSitename: 'tla-o-qui-aht',
    newSiteName: 'tla-o-qui-aht',
  },
  {
    family: 'Salish',
    language: 'Halkomelem',
    dialect: 'hən̓q̓əmin̓əm̓ XWCS',
    oldSitename: 'hən̓q̓əmin̓əm̓ XWCS',
    newSiteName: 'xwcs',
  },
]
export default LEGACY_SITE_MAPPING
